import { m } from "@/paraglide/messages.js";

export type PlayInjuryFreeSection = {
  heading: string;
  paragraphs: string[];
};

export type PlayInjuryFreeCallout = {
  label: string;
  body: string;
};

export type PlayInjuryFreeHero = {
  eyebrow: string;
  title: string;
  subtitle: string;
};

export function getStep06DialogTeaser(): string {
  return m.injury_content_step06_teaser();
}

export function getPlayInjuryFreeHero(): PlayInjuryFreeHero {
  return {
    eyebrow: m.injury_content_hero_eyebrow(),
    title: m.injury_content_hero_title(),
    subtitle: m.injury_content_hero_subtitle(),
  };
}

export function getPlayInjuryFreeSections(): PlayInjuryFreeSection[] {
  return [
    {
      heading: m.injury_content_section_0_heading(),
      paragraphs: [
        m.injury_content_section_0_paragraphs_0(),
        m.injury_content_section_0_paragraphs_1(),
      ],
    },
    {
      heading: m.injury_content_section_1_heading(),
      paragraphs: [
        m.injury_content_section_1_paragraphs_0(),
        m.injury_content_section_1_paragraphs_1(),
        m.injury_content_section_1_paragraphs_2(),
      ],
    },
    {
      heading: m.injury_content_section_2_heading(),
      paragraphs: [
        m.injury_content_section_2_paragraphs_0(),
        m.injury_content_section_2_paragraphs_1(),
        m.injury_content_section_2_paragraphs_2(),
      ],
    },
    {
      heading: m.injury_content_section_3_heading(),
      paragraphs: [
        m.injury_content_section_3_paragraphs_0(),
        m.injury_content_section_3_paragraphs_1(),
      ],
    },
    {
      heading: m.injury_content_section_4_heading(),
      paragraphs: [
        m.injury_content_section_4_paragraphs_0(),
        m.injury_content_section_4_paragraphs_1(),
      ],
    },
  ];
}

export function getPlayInjuryFreeAudienceCallouts(): readonly PlayInjuryFreeCallout[] {
  return [
    {
      label: m.injury_content_callout_0_label(),
      body: m.injury_content_callout_0_body(),
    },
    {
      label: m.injury_content_callout_1_label(),
      body: m.injury_content_callout_1_body(),
    },
    {
      label: m.injury_content_callout_2_label(),
      body: m.injury_content_callout_2_body(),
    },
  ];
}
